import UserModel from '@/models/User';

const GET_USER_CENTER_INFO = 'GET_USER_CENTER_INFO';
const GET_DISTRIBUTION_STATUS_INFO = 'GET_DISTRIBUTION_STATUS_INFO';

/**
 * 获取个人中心数据
 */
async function getUserCenterInfo() {
  const payload = await new UserModel().userCenterInfo();
  return {
    type: GET_USER_CENTER_INFO,
    payload
  }
}

/**
 * 获取分销员状态信息
 */
async function getDistributionStatusInfo() {
  const payload = await new UserModel().distributionStatusInfo();
  return {
    type: GET_DISTRIBUTION_STATUS_INFO,
    payload
  }
}

const ACTION_TYPES = {
  GET_USER_CENTER_INFO,
  GET_DISTRIBUTION_STATUS_INFO,
};

const ACTION = {
  getUserCenterInfo,
  getDistributionStatusInfo,
};

const UserCenter = {
  ACTION_TYPES,
  ACTION
}

export default UserCenter;